import React from 'react';

import styles from './splashBall.scss';

/**
 * @param {string} [size] 'small' or 'medium'
 */

const SplashBall = ({ title, description, size }) => {
    // If size is provided, use inline version with size class
    // Otherwise, use full-screen version (default)
    const containerClass = size
        ? `${styles.loadingIndicator} ${size === 'small' ? styles.small : styles.medium}`
        : styles.loadingPage;

    return (
        <div className={containerClass}>
            <div className={styles.innerWrapper}>
                <div className={styles.iconWrapper}>
                    <i className="icon-utr-logo" />
                    <div className={styles.iconSpinner} />
                    <div className={`${styles.iconSpinner} ${styles.reverse}`} />
                </div>
                {!!title && <div className={styles.title}>{title}</div>}
                {!!description && <div className={styles.description}>{description}</div>}
            </div>
        </div>
    );
};

export default SplashBall;
